import axiosClient from "./axiosClient";

export const getDocumentTemplates = () =>
  axiosClient.get("/settings/document-templates/");

export const getDocumentTemplateFieldReference = (templateType) =>
  axiosClient.get(`/settings/document-templates/field-reference/${templateType}/`);

export const createDocumentTemplate = (formData) =>
  axiosClient.post("/settings/document-templates/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateDocumentTemplate = (templateId, formData) =>
  axiosClient.patch(`/settings/document-templates/${templateId}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteDocumentTemplate = (templateId) =>
  axiosClient.delete(`/settings/document-templates/${templateId}/`);

export const downloadDocumentTemplate = (templateId) =>
  axiosClient.get(`/settings/document-templates/${templateId}/download/`, {
    responseType: "blob",
  });
